import React, { useState } from 'react';
import { observer } from 'mobx-react';

import { useStore } from 'stores';
import Loading from 'components/Loading';
import { FormCard } from 'components/Card';
import { ErrorMessage } from 'components/Message';
import { TokensIcon } from 'components/Icon';

import { CreateForm, UserInput } from './CreateForm';

export const Page: React.FC = observer(() =>
{
  const { uiStore, requesterTokenStore } = useStore();
  const [userInput, setUserInput] = useState<UserInput>({});

  return (
    <article className="page audience requesterToken-create">
      <FormCard>
      {
        requesterTokenStore.requesterToken.isLoading
        ? <><h1>{uiStore.labels.common.loading}</h1><Loading /></>
        : <>
            <h1><TokensIcon />{uiStore.labels.pages.audience.pages.requesterTokenCreate.title}</h1>
            {requesterTokenStore.requesterToken.errorMessage ? <ErrorMessage>{requesterTokenStore.requesterToken.errorMessage}</ErrorMessage> : null}
            <CreateForm userInput={userInput} saveUserInput={(input: UserInput) => setUserInput(prev => input)} />
          </>
      }
      </FormCard>
    </article>
  );
});